import React from 'react'
import GiftContext from '../../../context/context'
import Field from '../../common/field'

export default class FormPasswordRecovery extends React.Component {
  static contextType = GiftContext

  handleBack = () => {
    this.props.onChangeForm('login')
  }

  render() {
    return (
      <GiftContext.Consumer>
        {({ formContent, formData, handleChangeField, renderError }) => (
          <div className="form-state --password-recovery">
            <div className="form-field field-email">
              <Field
                label={formContent.texts.email}
                id="email"
                name="email"
                type="text"
                clean="false"
                value={formData.email}
                hasError={
                  renderError('email') ||
                  renderError('email.notvalid') ||
                  renderError('email.exists')
                }
                onChange={handleChangeField}
              />
            </div>
            <button type="button" className="recovery-buttom mb-3" onClick={this.handleBack}>
              {formContent.texts.backToLogin}
            </button>
            {this.props.recoveryMessage && <div className="form-message">{this.props.recoveryMessage}</div>}
          </div>
        )}
      </GiftContext.Consumer>
    )
  }
}
